{
  "breadcrumbAriaLabel": "パンくずリスト",
  "homeAriaLabel": "ホーム",
  "mainNavAriaLabel": "メインナビゲーション",
  "closeSidebarAriaLabel": "サイドバーを閉じる",
  "collapse": "折りたたむ",
  "help": "ヘルプ",
  "settings": "設定",
  "myProfile": "マイプロフィール",
  "groups": {
    "clinical": "診療",
    "worklists": "ワークリスト",
    "documentation": "診療文書",
    "orders": "オーダー",
    "medications": "薬剤",
    "scheduling": "予約管理",
    "billing": "会計",
    "analytics": "分析",
    "organization": "組織",
    "security": "セキュリティ",
    "accessReviews": "Access Reviews",
    "integrations": "連携",
    "system": "システム",
    "licensing": "ライセンス"
  },
  "dashboard": "ダッシュボード",
  "patients": "患者",
  "patientSearch": "患者検索",
  "myPatients": "担当患者",
  "censusBedBoard": "在院 / ベッドボード",
  "providerDirectory": "医師ディレクトリ",
  "providerCoverage": "医師カバレッジ",
  "patientMerge": "患者統合",
  "inbox": "受信箱",
  "pendingResults": "未確認結果",
  "criticalResults": "緊急結果",
  "unsignedNotes": "未署名ノート",
  "cosignQueue": "共同署名キュー",
  "noteTemplates": "ノートテンプレート",
  "smartPhrases": "スマートフレーズ",
  "orderCatalog": "オーダーカタログ",
  "orderSets": "オーダーセット",
  "encounters": "診療記録",
  "orders": "オーダー",
  "results": "検査結果",
  "medications": "薬剤",
  "notes": "診療ノート",
  "medicationWorklist": "Medication Worklist",
  "formulary": "院内採用薬",
  "pharmacistQueue": "薬剤師チェックキュー",
  "appointments": "予約",
  "scheduleManagement": "スケジュール管理",
  "waitlist": "待機リスト",
  "charges": "請求項目",
  "claims": "保険請求",
  "payments": "入金",
  "accounts": "アカウント",
  "statements": "明細書",
  "denials": "支払拒否",
  "analyticsDashboard": "ダッシュボード",
  "reports": "レポート",
  "qualityMeasures": "品質指標",
  "healthSystems": "医療法人",
  "facilities": "施設",
  "locations": "ロケーション",
  "clinicalTaxonomy": "臨床分類",
  "serviceLocation": "サービス ↔ ロケーション",
  "providers": "医療従事者",
  "users": "ユーザー",
  "roles": "ロール",
  "accessMatrix": "アクセスマトリクス",
  "integrations": "連携",
  "thirdPartyApps": "サードパーティアプリ",
  "audit": "監査",
  "system": "システム",
  "cdsRules": "CDS ルール",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "検索",
    "register": "登録",
    "demographics": "基本情報",
    "census": "在院",
    "discharge": "退院",
    "catalog": "カタログ",
    "sets": "オーダーセット",
    "pending": "未処理",
    "critical": "緊急",
    "reconciliation": "薬剤照合",
    "worklist": "ワークリスト",
    "templates": "テンプレート",
    "smartPhrases": "スマートフレーズ",
    "schedule": "スケジュール管理",
    "quality": "品質指標",
    "administration": "管理",
    "auditLog": "監査ログ",
    "allergies": "アレルギー",
    "problems": "問題リスト",
    "immunizations": "予防接種",
    "insurance": "保険"
  },
  "handoffs": "申し送り",
  "duplicateReview": "重複レビュー",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "オーダーワークリスト"
}
